import a2bConfig from '@olxeu-a2b/config';

export default function i18n() {
  const values = a2bConfig[a2bConfig.defaultLanguage].i18n;
  if (!values) {
    throw new Error('Missing a2b config with translations');
  }
  return values as unknown as Record<string, string>;
}
